import { FC } from 'react';
import OrderTable from './Table';

interface IProps {
  isNext?: string;
}

const OrderPage: FC<IProps> = ({ isNext }) => <OrderTable isNext={isNext} />;
export default OrderPage;
